import { configureStore } from '@reduxjs/toolkit';
import * as Sentry from '@sentry/react';
import { useDispatch } from 'react-redux';
import reducer, { middleware as rootMiddleware } from './rootReducer';

const sentryReduxEnhancer = Sentry.createReduxEnhancer({
    // Optionally pass options listed below
});

const store = configureStore({
    reducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }).concat(...rootMiddleware),
    enhancers: (getDefaultEnhancers) =>
        getDefaultEnhancers().concat(sentryReduxEnhancer),
});

export type ThisAppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;

export const { dispatch } = store;
export const useAppDispatch = () => useDispatch<ThisAppDispatch>();
export default store;
